<template>
  <Modal>
    <Modal.Title>Share this file</Modal.Title>
    <Modal.Body>
      <ShareBody :file="file" />
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { Modal } from '@dacr/library'
import type { File } from '@/shared/graphql/router/graphql'
import ShareBody from './ShareBody.vue'

defineProps<{
  file: File
}>()
</script>
